module.exports = __webpack_public_path__ + "img/dltAdvanceSearch.0ade4ae5.svg";